import React from 'react';

/**
 * TimeExpiredBox Component
 * 
 * Displays a notification when the timer has expired, prompting the user to submit their work.
 * 
 * @param {Object} props
 * @param {boolean} props.isVisible - Whether the box should be visible
 * @param {Function} props.onSubmit - Function to call when the submit button is clicked
 * @param {string} props.buttonText - Text to display on the submit button
 * @returns {JSX.Element|null} A notification box or null if not visible
 */
function TimeExpiredBox({ isVisible, onSubmit, buttonText = "Submit" }) {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-40 bg-black bg-opacity-50">
      <div className="bg-yellow-100 border-2 border-yellow-500 text-yellow-700 p-8 rounded-lg shadow-xl max-w-md animate-bounce-once">
        <div className="flex items-center mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 mr-4 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <h3 className="text-2xl font-bold">Time's Up!</h3>
        </div>
        <p className="mb-3 text-lg">Submit your answers now or the evaluation will be marked as expired.</p>
        <button 
          onClick={onSubmit}
          className="mt-4 w-full bg-yellow-600 hover:bg-yellow-700 text-white font-bold py-3 px-4 rounded-lg transition-colors duration-200 shadow-md hover:shadow-lg text-lg"
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
}

export default TimeExpiredBox;
